import { labelArchivio } from "_constants";
import { HeaderMainContent, HeaderTableContent } from "components/shared";
import { ButtonAddSource } from "components/buttons";
import {
  InputSearchSources,
  InputSourceTopic,
  SourcesTable,
} from "./components";

export const SourcesPage = () => {
  return (
    <>
      <HeaderMainContent child={<ButtonAddSource />} label={labelArchivio} />
      <HeaderTableContent
        child={
          <>
            <InputSearchSources />
            <InputSourceTopic />
          </>
        }
      />
      <SourcesTable />
    </>
  );
};
